import './video-controls-overlay.scss'

export function setupVideoControlsOverlay(player, elem) {
  const container = elem.closest('.video-js')
  let hideOverlayTimeout = null

  container.append(`
    <div class="video-js--controls-overlay">
      <div class="video-js--controls-overlay__actions">
        <button type='button' id="video-js--controls-overlay__actions-seek-back">
          <span class="icon icon-seek-back"></span>
        </button>
        <button type='button' id="video-js--controls-overlay__actions-play">
          <span class="icon icon-playback"></span>
        </button>
        <button type='button' id="video-js--controls-overlay__actions-seek-forward">
          <span class="icon icon-seek-forward"></span>
        </button>
      </div>
    </div>
  `)

  const playVideoCallback = (e) => {
    // Remove focus from button to not steal keyboard clicks from video player
    e.currentTarget.blur()

    setTimeout(() => {
      if (player.paused()) {
        player.play()
      } else {
        player.pause()
      }
    }, 0)
  }

  const seek = (direction, seconds) => {
    return (e) => {
      e.currentTarget.blur()

      const now = player.currentTime()

      if (direction === 'forward') {
        let duration = player.duration()

        player.currentTime(Math.min(now + seconds, duration))
      } else if (direction === 'back') {
        player.currentTime(Math.max(0, now - seconds))
      }
    }
  }

  // When swithing between normal and theater mode, the control bar sometimes bugs out and
  // doesn't hide automatically. But we always want to hide the overlay after inactivity, even
  // if the control bar is still visible.
  // As a fallback, we listen to mouse and touch events and manually hide the overlay after 3
  // seconds of no user actions.
  const showOverlay = (e) => {
    if (
      e.target.closest('.video-js') == container[0] &&
      container.hasClass('vjs-has-started')
    ) {
      // Reset timeout
      if (hideOverlayTimeout) {
        clearTimeout(hideOverlayTimeout)
        hideOverlayTimeout = null
      }

      // Show overlay immediately
      container.removeClass('vjs-video-controls-overlay-hidden')

      // Hide overlay in 3 seconds
      hideOverlayTimeout = setInterval(() => {
        container.addClass('vjs-video-controls-overlay-hidden')
      }, 3000)
    }
  }

  container
    .find('#video-js--controls-overlay__actions-play')
    .on('click', playVideoCallback)

  container
    .find('#video-js--controls-overlay__actions-seek-back')
    .on('click', seek('back', 15))

  container
    .find('#video-js--controls-overlay__actions-seek-forward')
    .on('click', seek('forward', 30))

  container.on('mousemove', showOverlay)
  container.on('touchstart', showOverlay)
}
